<template>
    <div class="progress-component flex m-a-between s-a-center">
      <p class="progress-time current">{{progressObject.currentTime | toTimeStamp}}</p>
      <div class="progress-track">
        <div class="progress-bar" :style="`width: ${progress}%;`"></div>
      </div>
      <p class="progress-time total">{{progressObject.duration | toTimeStamp}}</p>
    </div>
</template>

<script>
export default {
  name: "progressBar",
  props: ["progressObject"],
  data: () => {
    return {};
  },
  methods: {},
  computed: {
    progress () {
      return this.progressObject.currentTime / this.progressObject.duration * 100;
    }
  },
  filters: {
    toTimeStamp: (value) => {
      if (!value) value = 0;
      let secondsInput = parseInt(value);
      let hours = Math.floor(secondsInput / 3600);
      let minutes = Math.floor(secondsInput / 60) % 60;
      let seconds = secondsInput % 60;

      return [hours,minutes,seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v,i) => v !== "00" || i > 0)
        .join(":")
    }
  }
};
</script>

<style scoped>
    .progress-component {
      flex: 7;
      margin: 0 2rem;
    }
    .progress-track {
      background: rgb(232, 232, 232);
      height: 10px;
      overflow: hidden;
      border-radius: 20px;
      flex: 7;
      margin: 0 1rem;
    }
    .progress-bar {
      background: linear-gradient(-45deg, hsla(37, 100%, 60%, 1), hsla(37, 100%, 70%, 1));
      height: 100%;
      width: 0%;
      transition: width .2s linear;
    }
    .progress-time {
      text-align: center;
    }
</style>